/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Aspect_Instagram_SquareInputs */

const cs_template_aspect_instagram_square = /** @type {(inputs: Template_Aspect_Instagram_SquareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram čtverec`)
};

const en_template_aspect_instagram_square = /** @type {(inputs: Template_Aspect_Instagram_SquareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram square`)
};

/**
* | output |
* | --- |
* | "Instagram square" |
*
* @param {Template_Aspect_Instagram_SquareInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const template_aspect_instagram_square = /** @type {((inputs?: Template_Aspect_Instagram_SquareInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Aspect_Instagram_SquareInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_aspect_instagram_square(inputs)
	return cs_template_aspect_instagram_square(inputs)
});